import { styled } from '@mui/system';
import { Button, Paper, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2)
  },
  '&:empty': {
    display: 'none'
  }
}));

export const HintContainer = styled('aside')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  padding: theme.spacing(),
  marginBottom: theme.spacing()
}));

export const HintIcon = styled(InfoIcon)(({ theme }) => ({
  width: 20,
  marginRight: theme.spacing(),
  color: 'rgba(0, 0, 0, 0.54)'
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(1)
}));

export const HintText = styled(Typography)(() => ({
  fontSize: 16
}));

export const AddButtonIcon = styled(AddCircleOutlineRoundedIcon)(() => ({
  fontSize: 16
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));

export const ButtonContainer = styled('div', {
  shouldForwardProp: prop =>
    prop !== 'isFormEnabled' && prop !== 'isIntersecting'
})(({ theme, isFormEnabled, isIntersecting }) => ({
  position: 'sticky',
  bottom: 0,
  backgroundColor: '#EEE',
  zIndex: theme.zIndex.appBar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: isFormEnabled ? 'space-between' : 'end',
  padding: theme.spacing(),
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),

  ...(!isIntersecting && {
    borderTop: `1px solid ${theme.palette.grey[400]}`,
    boxShadow: 'rgba(0, 0, 0, 0.45) 0px -17px 20px -22px'
  })
}));
